module.exports = __webpack_public_path__ + "img/gyl_IOS.93e77207.png";